class AnimatedBanner extends HTMLElement {
	constructor() {
		super();
		this.tl = null;
		this._lastState = null;
		this._internalStateChange = false;
	}

	connectedCallback() {
		this.ready = true;
		this.skip = this.dataset.skipAnimation === "true";
		this.showOnce = this.dataset.showOnce === "true";
		this.hasSeen = this.showOnce ? this.getCookie() : false;
		this.stateTransition = parseFloat(getComputedStyle(this).getPropertyValue('--transition').trim()) || 2.5;

		if (!this.hasSeen) this.setCookie('true', 30);
	}

	get isFront() { return document.querySelector('#wrapper') };

	static get observedAttributes() {
		return ['state'];
	}

	attributeChangedCallback(name, oldValue, newValue) {
		if (name === 'state') this.onAnimationChange()
	}

	play() {
		if (!this.isFront) return this.skipToEnd();
		if (this.skip) return this.skipToEnd();
		if (this.showOnce && this.hasSeen) return this.skipToEnd();

		this.setAttribute('state', 'start');

	}

	getTimeLine(options) {
		this.tl = gsap.timeline(options);

		this.tl.setState = (state, cb = () => { }) => {
			this.tl.addLabel(state)
				.call(() => {
					this.state = state;
					cb();
				})

			return this.tl
		}
		return this.tl;
	}

	get state() { return this.getAttribute('state') }
	set state(state) {
		if (this._lastState && state === this._lastState) return;

		this._lastState = this.state;
		this._internalStateChange = true;
		this.setAttribute('state', state);


		setTimeout(() => this._internalStateChange = false);
	}

	onAnimationChange = () => {
		if (!this.tl) return console.warn('[ AnimationChange ] : No tl');

		if (this._internalStateChange) return;

		const isPaused = this.hasAttribute('pause', false);
		console.log(`[ state ] ${isPaused ? 'Go' : 'Animating'} to:`, this.state);

		if (isPaused) return this.tl.seek(this.stat, false);

		if (this.tl.labels[this.state] === null) return console.warn('No label found:', this.state);
		this.tl.play(this.state, false);
	}

	skipToEnd() {
		console.log(`Skipping animation:`, { showOnce: this.showOnce, skip: this.skip });

		this.skipped = true;
		if (!this.tl) return console.warn('no tl');
		this.classList.toggle('no-transition', true);
		this.tl.progress(1);

		setTimeout(() => {
			this.classList.toggle('no-transition', false);
		}, 0);
	}

	getCookie() {
		const name = `animated_banner_${this.dataset.clientId}`
		const v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
		return v ? v[2] : null;
	}

	setCookie(value, days) {
		const name = `animated_banner_${this.dataset.clientId}`
		const d = new Date();
		d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
		document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
	}

	disconnect() {
		if (this.tl) this.tl.kill();
	}

	onImageReady = (sel, cb) => {
		const img = typeof sel === 'string' ? this.querySelector(sel) : sel;
		if (!img) return;
		if (img.complete && img.naturalWidth !== 0) cb();
		else img.addEventListener('load', cb, { once: true });
	}

	getCoverPosition(img, targetImageX) {
		const { width: vw, height: vh } = this.getBoundingClientRect();

		const iw = img.naturalWidth;
		const ih = img.naturalHeight;

		const scale = Math.max(vw / iw, vh / ih);

		const scaledTargetX = targetImageX * scale;
		const scaledWidth = iw * scale;

		const desiredOffsetPx = scaledTargetX - vw / 2;
		const overflowX = scaledWidth - vw;

		const objectPosX = (desiredOffsetPx / overflowX) * 100;

		return `${objectPosX}% bottom`;
	}
}

customElements.define('animated-banner', AnimatedBanner);
